import { useState, useEffect } from "react";
import {VectorMap} from "devextreme-react/vector-map";
import worldMap from "devextreme-dist/js/vectormap-data/world.js";
import useMapData from "../../../../hooks/use-map-data.ts";
import MapData from "./map-data.ts";
import SimpleLoadingIndicator from "../../../../components/simple-loading-indicator";

export interface MapComponentProps {
    selectedLocalisation: number;
    selectedOption: string;
    selectedDateRange: Date[]
}

const MapComponent = ({ selectedLocalisation, selectedOption, selectedDateRange }: MapComponentProps) => {
    const {data, isLoading} = useMapData(selectedLocalisation, selectedDateRange[0], selectedDateRange[1], selectedOption);
    const [mapData, setMapData] = useState<MapData | null>(null);
    
    useEffect(() => {
        if (data && data.length > 0) {
            const newMapData = new MapData(data);
            setMapData(newMapData);
        }
    }, [data]);
    
    return (
        <div className={"relative w-full h-full"}>
            <VectorMap
                center={mapData?.center ?? [2.3, 47]}
                zoomFactor={15}
                layers={[
                    {
                        dataSource: worldMap.world,
                        hoverEnabled: false,
                        color: "#d3d3d3", // Couleur des zones
                    },
                    {
                        name: "bubbles",
                        dataSource: mapData?.dataSource,
                        elementType: "bubble",
                        dataField: "value",
                        minSize: 20,
                        maxSize: 40,
                        sizeGroupingField: "value"
                    },
                ]}
                tooltip={{
                    enabled: true,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    customizeTooltip: (arg: any) =>
                        arg.layer.type === "marker" ? { text: arg.attribute("tooltip") } : null,
                }}
                legends={[
                    {
                        source: { layer: "bubbles", grouping: "size" },
                        markerShape: "circle",
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        customizeText: (arg: any) =>
                            `${arg.start} to ${arg.end}`, // Correction de la légende
                    },
                ]}
            />

            {isLoading &&
                <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
                    <SimpleLoadingIndicator text={'Chargement de la carte'}/>
                </div>}

        </div>
    );
};

export default MapComponent;
